<template>
  <div class="request-card d-flex i-py-9 i-px-10 align-items-center i-mb-6">
    <div
      class="request-card__icon d-flex align-items-center justify-content-center"
    >
      <i-icon :symbol="icon" />
    </div>
    <div class="d-flex flex-grow-1 justify-content-between align-items-center">
      <div class="request-card__content i-ml-8">
        <h3
          class="i-text-button-2 i-text-neutral-120 i-mb-2 d-flex align-items-center"
        >
          {{ title }}
          <span v-if="newLabel" class="i-ml-3 i-pill i-text-subheading-3"
            ><span class="primary">New</span></span
          >
        </h3>
        <p class="i-text-body-2 i-text-neutral-110">{{ description }}</p>
      </div>
      <div class="request-card__button d-flex align-items-center">
        <i-button text="Add" size="sm" @button-click="addRequest()"></i-button>
      </div>
    </div>
  </div>
</template>

<script>
import { iButton, iIcon } from '@inscribe/signal';

export default {
  name: 'RequestCard',
  components: {
    iButton,
    iIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    newLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addRequest() {
      this.$emit('add-request');
    },
  },
};
</script>

<style lang="scss" scoped>
.request-card {
  border: 1px solid $light-neutral-60;
  width: 100%;
  border-radius: 20px;

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: $light-primary-30;

    .i-icon {
      color: $light-primary-90 !important;
    }
  }

  &__content {
    position: relative;
    .i-pill {
      display: block;
      position: absolute;
      right: 0;
    }
  }
}
</style>
